import { FC, SVGAttributes } from 'react';

const ExternalPerson: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.87651 15.207C6.03251 15.207 2.74951 15.788 2.74951 18.116C2.74951 20.444 6.01251 21.046 9.87651 21.046C13.7215 21.046 17.0035 20.464 17.0035 18.137C17.0035 15.81 13.7415 15.207 9.87651 15.207Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.87648 11.886C12.3995 11.886 14.4445 9.841 14.4445 7.318C14.4445 4.795 12.3995 2.75 9.87648 2.75C7.35448 2.75 5.30948 4.795 5.30948 7.318C5.30048 9.832 7.33048 11.877 9.84548 11.886H9.87648Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18 13L23 8M23 8V12.5M23 8H18.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ExternalPerson;
